import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-grades',
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.css']
})
export class GradesComponent extends BaseCrudComponent {

    translations: any;
    loadingRequired: any;
    subjects: any;
    agents: any;
    subject_sel: any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = 'SalesGeneralInformation/Score/GetBySubject';
        this.create_url = 'SalesGeneralInformation/Subject/Score/Create';
        this.update_url = 'SalesGeneralInformation/Subject/Score/Update';
        this.delete_url = 'SalesGeneralInformation/Subject/Score/LogicalDelete';
        this.search_fields = ['agentName', 'score'];
        
        this.subjects = [];
        this.agents = [];
        this.subject_sel = null;

        this.loadingRequired = false;

        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                //this.getList();

                this.loadingList = true;
                this.getFiltersData().subscribe(d => {
                    this.loadingList = false;
                    if (d != false) {
                        this.subjects = d;
                    }
                });
            });
    }

    public getList(){
        var qst = this.read_url;

        if( this.subject_sel == null ){
            Swal.fire('Debe seleccionar una materia', '', 'error');
            return;
        }
        
        this.loadingList = true;
        this.srv.postCall(qst, {subjectId: this.subject_sel.id}).subscribe(x => {
            this.loadingList = false;

            if(x.status){
                this.rawdata = x.data;
                this.rows = x.data;
                this.page = 1;

                if( Array.isArray(this.rows) ){
                    this.pageTotal = this.rows.length;
                }
            }
            else{
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public getFiltersData() {
        var par_url = 'SalesGeneralInformation/Subject/All';

        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    openCreateModal(content: any) {
        this.c_obj = {};

        if( this.subject_sel == null ){
            Swal.fire('Debe seleccionar una materia', '', 'error');
            return;
        }

        super.openCreateModal(content);
        this.loadingRequired = true;
        
        this.getAgentsData().subscribe(x => {
            this.loadingRequired = false;
            if (x != false) {
                this.agents = x;
            }
        });
    }

    openUpdateModal(content: any, obj: any) {
        //console.log(obj);
        obj['subject_name'] = this.subject_sel.name;
        super.openUpdateModal(content, obj);
    }

    validateCreateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'agent': new FormControl(fields.agent, [Validators.required]),
            'score': new FormControl(fields.score, [Validators.required])
        });

        return mygroup.valid;
    }

    validateUpdateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'id': new FormControl(fields.id, [Validators.required]),
            'score': new FormControl(fields.score, [Validators.required])
        });

        return mygroup.valid;
    }

    public createItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }
        
        validated = this.validateCreateInfo(form);

        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.subjectId = this.subject_sel.id;
        to.agentCode = form['agent']['agentCode'];
        to.score = form['score'];

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if (x.status) {
                this.c_obj = {};
                this.getList();
                //this.closeModal(content);
                Swal.fire(this.translations.created, '', 'success');
            }//end success
            else {
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }

        validated = this.validateUpdateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.id = form.id;
        to.score = form['score'];

        //var qst = this.update_url + '/' + form.id;
        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                Swal.fire(x.message, '', 'error');
                //this.closeModal(content);
            }
        });
    }

    public getAgentsData() {
        var par_url = 'Agent/All';
        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    public getAgentsBackupData() {
      var par_url = 'AgentBackup/AllBackup';
      return this.srv.getCall(par_url).pipe(
          mergeMap(x => {
              let mydata: any = { status: false, message: '', data: [] };
              mydata = x;

              if (mydata.status == true) {
                  return of(mydata.data);
              }
              else {
                  return of(false);
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => of(false))
      );
    }

}
